module.exports = __webpack_public_path__ + "media/img/kanban/kanban-2-e9a03d33b5fd0be47630e32cfec3343e.jpg";